document.addEventListener('DOMContentLoaded', () => {
  const section = document.querySelector('.c_staff-blog-detail[data-leeep-tag-id]');
  if (!section || section.dataset.initialized === 'true') return;
  section.dataset.initialized = 'true';

  // ------------------------------------------------------------------
  // fetch をスコープ限定で monkey patch
  // LEEEPは LeeepCite.init({ shop_id }) を受け取らないため、関連ブログAPI
  // (/v3/blogs) に shop_id を注入するだけのために fetch を一時差し替える。
  // 状態はモジュールローカル（window 汚染しない）。マッチ次第・最大30秒で復元。
  // ------------------------------------------------------------------
  let activeFilter = null;
  let relatedBlogs = null;

  const patchFetchForRelatedBlogs = () => {
    const originalFetch = window.fetch;
    let restored = false;
    const restore = () => {
      if (restored) return;
      restored = true;
      // 自分が差し替えた wrapper の場合のみ元に戻す（他者が上書きしていたら触らない）
      if (window.fetch === wrapper) window.fetch = originalFetch;
    };

    const wrapper = function (input, init) {
      const filter = activeFilter;
      if (!filter || !filter.tagId) {
        return originalFetch.call(this, input, init);
      }

      const url = typeof input === 'string' ? input : (input && input.url);
      const isRelatedBlogsCall =
        typeof url === 'string' &&
        url.includes('/v3/blogs') &&
        url.includes('tag_id=' + filter.tagId);

      let finalInput = input;
      if (isRelatedBlogsCall && filter.shopId && !url.includes('shop_id=')) {
        const sep = url.includes('?') ? '&' : '?';
        const patched = url + sep + 'shop_id=' + encodeURIComponent(filter.shopId);
        finalInput = typeof input === 'string' ? patched : new Request(patched, input);
        // マッチ次第ラッパーを解除（影響範囲を最小化）
        activeFilter = null;
        restore();
      }

      const resPromise = originalFetch.call(this, finalInput, init);

      if (isRelatedBlogsCall) {
        resPromise.then((res) => {
          try {
            res.clone().json().then((data) => {
              const blogs = (data && (data.blogs || data)) || [];
              if (Array.isArray(blogs)) {
                relatedBlogs = blogs;
              }
            }).catch(() => { /* noop */ });
          } catch (e) { /* noop */ }
        }).catch(() => { /* noop */ });
      }

      return resPromise;
    };

    window.fetch = wrapper;
    // フェイルセーフ: マッチが来なくても 30 秒で必ず復元
    setTimeout(restore, 30000);
  };

  const tagId = section.dataset.leeepTagId;
  const paramName = section.dataset.blogIdParam || 'blog_id';
  const relatedTagId = section.dataset.leeepRelatedTagId;
  const area = section.querySelector('[data-leeep-area="staff-blog-detail"]');
  const relatedArea = section.querySelector('[data-leeep-related-area]');

  const showMessage = (message) => {
    if (area) area.textContent = message;
  };

  const urlParams = new URLSearchParams(window.location.search);
  const blogSlug = urlParams.get(paramName);

  if (!blogSlug) {
    showMessage('投稿が指定されていません。');
    return;
  }

  const renderLeeep = () => {
    if (!area || !tagId || typeof LeeepCite === 'undefined') return;
    area.textContent = '';
    const div = document.createElement('div');
    div.id = 'leeep-tag-' + String(tagId);
    area.appendChild(div);
    LeeepCite.init({
      tag_id: String(tagId),
      blog_id: String(blogSlug)
    });
  };

  const waitForLeeep = (count = 0) => {
    if (typeof LeeepCite !== 'undefined') { renderLeeep(); return; }
    if (count > 50) {
      showMessage('コンテンツの読み込みに失敗しました。ページを再読み込みしてください。');
      return;
    }
    setTimeout(() => waitForLeeep(count + 1), 100);
  };

  if (tagId) waitForLeeep();

  // ブレッドクラム更新
  const updateBreadcrumbFromDom = () => {
    if (section.dataset.breadcrumbUpdated === 'true') return true;

    const titleSelectors = [
      '.LeeepBlogTitle',
      '.LeeepBlogDetailTitle',
      '.LeeepBlogHeader h1',
      '.LeeepBlog h1',
      '.LeeepBlogDetail h1'
    ];

    let titleText = '';
    for (const selector of titleSelectors) {
      const el = area.querySelector(selector);
      if (el && el.textContent.trim()) {
        titleText = el.textContent.trim();
        break;
      }
    }

    if (!titleText) return false;

    const currentEl = section.querySelector('.c_breadcrumb__current');
    if (currentEl) currentEl.textContent = titleText;
    document.title = titleText;
    section.dataset.breadcrumbUpdated = 'true';
    return true;
  };

  const observer = new MutationObserver(() => {
    if (updateBreadcrumbFromDom()) observer.disconnect();
  });
  observer.observe(area, { childList: true, subtree: true });

  const COLUMNS_SELECTOR = '.LeeepBlogContentColumns, .LeeepBlogContentColumnsResponsive';
  const COLUMNS_ITEM_CLASS = 'LeeepBlogContentColumnsItem';

  const isColumnsBlock = (el) => !!el && el.nodeType === 1 && el.matches(COLUMNS_SELECTOR);
  const columnItemsOf = (el) =>
    Array.prototype.filter.call(el.children, (c) => c.classList.contains(COLUMNS_ITEM_CLASS));
  const isImageColumns = (el) => {
    const items = columnItemsOf(el);
    return items.length > 0 && items.every((item) => item.querySelector('img'));
  };
  const isTextColumns = (el) => {
    const items = columnItemsOf(el);
    return items.length > 0 && !el.querySelector('img');
  };

  const pairColumnBlocks = () => {
    if (!area) return;
    area.querySelectorAll('.LeeepBlogContent > div').forEach((wrap) => {
      Array.prototype.slice.call(wrap.children).forEach((block) => {
        if (!isColumnsBlock(block) || block.dataset.cPaired === 'true') return;
        if (!isImageColumns(block)) return;
        const next = block.nextElementSibling;
        if (!isColumnsBlock(next) || !isTextColumns(next)) return;
        const imageItems = columnItemsOf(block);
        const textItems = columnItemsOf(next);
        if (imageItems.length !== textItems.length) return;
        imageItems.forEach((item, i) => {
          while (textItems[i].firstChild) item.appendChild(textItems[i].firstChild);
        });
        next.remove();
        block.dataset.cPaired = 'true';
      });
    });
  };

  // 関連ブログリスト: ブログ詳細APIで shop_id を取得 → fetch patch で絞り込み → init
  const initRelatedBlogList = async () => {
    if (!relatedTagId || !relatedArea) return;
    if (section.dataset.__relatedInitialized === 'true') return;
    if (typeof LeeepCite === 'undefined') return;

    try {
      // ブログ詳細APIで現ブログの shop_id を取得
      const apiUrl = 'https://cite.leeep.jp/v3/blog?tag_id=' + encodeURIComponent(tagId)
        + '&website_id=' + encodeURIComponent(LeeepCite.site_id)
        + '&slug=' + encodeURIComponent(blogSlug);
      const res = await fetch(apiUrl);
      if (!res.ok) {
        console.warn('[staff-blog-detail] blog detail API failed:', res.status);
        return;
      }
      const blog = await res.json();
      const shops = blog && blog.post_user && blog.post_user.staff && blog.post_user.staff.shops;
      const shopId = shops && shops[0] && shops[0].id;

      if (!shopId) {
        console.warn('[staff-blog-detail] shop_id not found in blog detail');
        return;
      }

      // fetch を一時差し替えて LEEEPの /v3/blogs 呼び出しに shop_id を注入する
      activeFilter = {
        tagId: String(relatedTagId),
        shopId: String(shopId)
      };
      patchFetchForRelatedBlogs();

      // LEEEPの描画先 div を動的に作成
      const div = document.createElement('div');
      div.id = 'leeep-tag-' + String(relatedTagId);
      relatedArea.appendChild(div);

      // LeeepCite.init を呼ぶ → fetch patch で shop_id 付きリクエストが飛ぶ
      LeeepCite.init({ tag_id: String(relatedTagId) });

      section.dataset.__relatedInitialized = 'true';
    } catch (e) {
      console.error('[staff-blog-detail] related blog init failed:', e);
    }
  };

  // 関連ブログリストから現在のブログを除外
  // LEEEP は data-id ではなく <a href="...?blog_id=xxx"> として持っているため href で判定
  const excludeCurrentBlogFromRelated = () => {
    if (!relatedTagId || !blogSlug) return;
    const relatedRoot = document.querySelector('#leeep-embedded-' + String(relatedTagId));
    if (!relatedRoot) return;
    const links = relatedRoot.querySelectorAll('a.LeeepBlogListItemLink, a[href*="blog_id="]');
    links.forEach((a) => {
      try {
        const href = a.getAttribute('href') || '';
        const m = href.match(/[?&]blog_id=([^&]+)/);
        if (m && decodeURIComponent(m[1]) === blogSlug) {
          const item = a.closest('.LeeepBlogListItem') || a.parentElement;
          if (item) item.remove();
        }
      } catch (e) { /* noop */ }
    });
  };

  // 関連ブログリストの root に横スクロール用のクラスを付与
  const applyBlogListClass = () => {
    if (!relatedTagId) return;
    const relatedRoot = document.querySelector('#leeep-embedded-' + String(relatedTagId));
    if (relatedRoot && !relatedRoot.classList.contains('is-leeep-blog-list')) {
      relatedRoot.classList.add('is-leeep-blog-list');
    }
  };

  // 関連ブログのカードに日付を挿入
  // fetch patchで取得した relatedBlogs を使用
  const insertBlogDates = () => {
    if (!relatedTagId) return;
    const blogs = relatedBlogs;
    if (!Array.isArray(blogs) || blogs.length === 0) return;
    const relatedRoot = document.querySelector('#leeep-embedded-' + String(relatedTagId));
    if (!relatedRoot) return;
    const items = relatedRoot.querySelectorAll('.LeeepBlogListItem');
    if (items.length === 0) return;

    // blogs を slug でマップ化
    const blogMap = {};
    blogs.forEach((b) => { if (b && b.slug) blogMap[b.slug] = b; });

    items.forEach((item) => {
      if (item.dataset.__dateAdded === '1') return;
      const link = item.querySelector('a.LeeepBlogListItemLink');
      if (!link) return;
      const m = (link.getAttribute('href') || '').match(/[?&]blog_id=([^&]+)/);
      if (!m) return;
      const blog = blogMap[decodeURIComponent(m[1])];
      if (!blog || !blog.posted_at) return;
      const d = new Date(blog.posted_at);
      if (isNaN(d.getTime())) return;
      const dateStr = d.getFullYear() + '/'
        + ('0' + (d.getMonth() + 1)).slice(-2) + '/'
        + ('0' + d.getDate()).slice(-2);
      const dateIso = d.getFullYear() + '-'
        + ('0' + (d.getMonth() + 1)).slice(-2) + '-'
        + ('0' + d.getDate()).slice(-2);

      const titleEl = item.querySelector('.LeeepBlogListItemTitle');
      if (!titleEl) return;

      const dateEl = document.createElement('time');
      dateEl.className = 'LeeepBlogDate';
      dateEl.setAttribute('datetime', dateIso);
      dateEl.textContent = dateStr;
      titleEl.before(dateEl);
      item.dataset.__dateAdded = '1';
    });
  };

  // ヘッダー内のハッシュタグを記事下部の「関連のタグ」枠に移動
  // 同時に LEEEPのタグに共通コンポーネントクラス c_hashtag を付与
  const moveHashtagsToBottom = () => {
    const target = section.querySelector('[data-leeep-hashtags-target]');
    const hashtags = area.querySelector('.LeeepHashtagSection');
    if (!target || !hashtags) return;
    if (hashtags.dataset.__moved !== 'true') {
      target.appendChild(hashtags);
      hashtags.dataset.__moved = 'true';
    }
    // 各タグに共通クラスを付与（c_hashtag / c_hashtag--prefix）
    // ハッシュタグは他の一覧（コーデ/ランキング）と挙動を揃え、LEEEP標準のチップ式(?hashtag=)
    // ではなく一覧のチェックボックス絞り込みを適用する。条件はURLではなく sessionStorage で
    // 渡す（c_staff-blog.js が読み取り後に削除）。冪等：リンク先・ハンドラの二重付与を防ぐ。
    hashtags.classList.add('c_hashtag-list');
    hashtags.querySelectorAll('.LeeepHashtag').forEach((el) => {
      el.classList.add('c_hashtag', 'c_hashtag--prefix');
      const name = (el.textContent || '').trim();
      if (!name) return;
      // LEEEP標準リンク（?hashtag=… 等）を初回に退避（再実行でhrefが上書き済みでも保持）。
      // sessionStorage が使えない環境（private mode 等）のフォールバック遷移先に使う。
      if (!el.dataset.cNativeHref) el.dataset.cNativeHref = el.getAttribute('href') || '';
      const nativeHref = el.dataset.cNativeHref;
      let path = '/pages/staff-blog';
      try { path = new URL(nativeHref || path, location.origin).pathname; } catch (e) { /* デフォルトを使用 */ }
      el.setAttribute('href', path);
      if (el.dataset.cFilterBound !== '1') {
        el.dataset.cFilterBound = '1';
        el.addEventListener('click', (e) => {
          // 中クリックや Cmd/Ctrl/Shift+クリック（新規タブ/ウィンドウ）は元タブが遷移しないため、
          // sessionStorage に値が残り別の一覧で誤消費される。書き込まずにそのまま遷移させる。
          if (e.button !== 0 || e.ctrlKey || e.metaKey || e.shiftKey) return;
          // 宛先一覧を target で明示（3一覧でキー共有のためクロス消費を防ぐ）。
          let stored = false;
          try {
            sessionStorage.setItem('c_leeepPendingFilters', JSON.stringify({ target: 'staff-blog', values: [name] }));
            stored = true;
          } catch (err) { /* private mode / 容量超過等で失敗 */ }
          // sessionStorage が使えない場合は LEEEP標準リンクで遷移（チップ式表示になるが
          // 絞り込み・クリアは LEEEP 側で正常動作する）。素の一覧へ落とすより機能を維持する。
          if (!stored && nativeHref) {
            e.preventDefault();
            location.href = nativeHref;
          }
        });
      }
    });
  };

  // 投稿者の身長表示に足サイズを追加（「155cm」→「155cm / 23.0cm」）
  // /v3/staffs?staff_id=X の properties から「足のサイズ」を取得
  const appendFootSizeToAuthor = async () => {
    if (section.dataset.__authorFootAdded === 'true') return;
    if (typeof LeeepCite === 'undefined' || !LeeepCite.site_id) return;

    const authorLink = area.querySelector('.LeeepBlogDetailAuthorLink');
    const href = authorLink ? authorLink.getAttribute('href') || '' : '';
    const m = href.match(/staff_id=([^&]+)/);
    if (!m) return;
    const staffId = decodeURIComponent(m[1]);

    try {
      const res = await fetch(
        'https://cite.leeep.jp/v3/staffs?website_id=' + encodeURIComponent(LeeepCite.site_id)
        + '&staff_id=' + encodeURIComponent(staffId)
      );
      if (!res.ok) return;
      const data = await res.json();
      const staff = data && data.staffs && data.staffs[0];
      if (!staff) return;
      // properties は staff.staff.properties にネストされている可能性もある
      const props = staff.properties || staff.staff_properties
        || (staff.staff && staff.staff.properties) || [];
      const foot = props.find((p) => p && p.key && p.key.name === '足のサイズ');
      if (!foot || !foot.value) return;
      // foot.value は {code, name} オブジェクトの場合がある
      const footText = (typeof foot.value === 'object') ? (foot.value.name || foot.value.code) : foot.value;
      if (!footText) return;

      const heightEl = area.querySelector('.LeeepBlogDetailAuthorHeight');
      if (!heightEl) return;
      const heightText = (heightEl.textContent || '').trim();
      heightEl.textContent = heightText + ' / ' + footText + 'cm';
      section.dataset.__authorFootAdded = 'true';
    } catch (e) {
      console.warn('[staff-blog-detail] staff API failed:', e);
    }
  };

  // 関連リスト描画後の処理を実行
  const onRelatedRendered = () => {
    applyBlogListClass();
    excludeCurrentBlogFromRelated();
    insertBlogDates();
  };

  // 関連リストDOM出現を MutationObserver で検知（固定タイムアウト依存を排除）
  const watchRelatedAreaRendering = () => {
    if (!relatedArea || !relatedTagId) return;
    const observer = new MutationObserver(() => {
      const root = document.querySelector('#leeep-embedded-' + String(relatedTagId));
      const items = root && root.querySelectorAll('.LeeepBlogListItem');
      if (items && items.length > 0) {
        onRelatedRendered();
        observer.disconnect();
      }
    });
    observer.observe(relatedArea, { childList: true, subtree: true });
    // フェイルセーフ: 10秒後に observer を切断（無限監視防止）
    setTimeout(() => observer.disconnect(), 10000);
  };

  // ブログ詳細の描画完了を検知（onLeeepContentsRendered が発火しないため MutationObserver で）
  const detailReadyObserver = new MutationObserver(() => {
    const titleEl = area && area.querySelector('.LeeepBlogDetailTitle');
    if (titleEl && titleEl.textContent.trim()) {
      pairColumnBlocks();
      moveHashtagsToBottom();
      appendFootSizeToAuthor();
      initRelatedBlogList();
      watchRelatedAreaRendering();
      detailReadyObserver.disconnect();
    }
  });
  detailReadyObserver.observe(area, { childList: true, subtree: true });

  // onLeeepContentsRendered も一応保持（将来仕様変更で発火する可能性）
  document.addEventListener('onLeeepContentsRendered', () => {
    pairColumnBlocks();
    updateBreadcrumbFromDom();
    excludeCurrentBlogFromRelated();
  });
});
